import { ACCESS_TOKEN, REFRESH_TOKEN } from "../../constants/api.constant";

export const getToken = (): string => sessionStorage.getItem(ACCESS_TOKEN);

export const getRefreshToken = (): string =>
  sessionStorage.getItem(REFRESH_TOKEN);
